import { render, staticRenderFns } from "./BookEntryLink.vue?vue&type=template&id=6c62f4e9&"
import script from "./BookEntryLink.vue?vue&type=script&lang=js&"
export * from "./BookEntryLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports